import * as React from "react";
import classNames from "classnames";

export const ToggleField: React.FC<{
  children?: React.ReactNode;
  label: string;
  isOn: boolean;
  setOn: () => void;
  setOff: () => void;
  disabled?: boolean;
}> = ({ label, isOn, setOn, setOff, disabled, children }) => {
  return (
    <div className="field">
      <div className="columns is-marginless is-paddingless is-mobile mb-1">
        <div className="column is-marginless is-paddingless">
          <label className="label">{label}</label>
        </div>
        <div className="column is-marginless is-paddingless">
          <div className="buttons is-small is-right has-addons">
            <button
              disabled={disabled}
              className={classNames("button is-small", {
                "is-selected": isOn,
                "is-success": isOn,
              })}
              onClick={setOn}
            >
              ON
            </button>
            <button
              disabled={disabled}
              className={classNames("button is-small", {
                "is-selected": !isOn,
                "is-success": !isOn,
              })}
              onClick={setOff}
            >
              OFF
            </button>
          </div>
        </div>
      </div>
      {isOn && children}
    </div>
  );
};
